import { FC } from 'react';
import { DisabledForm } from '../common/DisabledForm';
import { LINKS } from '@silo/types';
import { ExternalLink } from '@silo/ui';

export const BorrowingDisabled: FC = () => (
  <DisabledForm
    heading="Borrowing is currently disabled."
    paragraph="You can't open a borrow position when you have deposited all of the silo's assets."
    link={<ExternalLink href={LINKS.SILOPEDIA.DISABLED_BORROWING} size="normal" />}
  />
);
